<script setup>
import { computed, ref } from 'vue'
const props = defineProps({ report: { type: Object, required: true } })
const page = ref(0)
const citedIds = computed(() => new Set((props.report.chapters || []).flatMap(chapter => chapter.evidence_ids || [])))
const comments = computed(() => (props.report.evidence || []).filter(item => /comment/i.test(item.source_type || '')))
const visible = computed(() => comments.value.filter(item => citedIds.value.has(item.evidence_id)))
const platformLabel = value => ({ xiaohongshu: '小红书', douyin: '抖音', tiktok: 'TikTok' }[value] || value)
function safeUrl(value) { try { const u = new URL(value); return ['http:', 'https:'].includes(u.protocol) ? u.href : null } catch { return null } }
</script>
<template>
  <details v-if="visible.length" class="report-evidence">
    <summary>报告引用的评论</summary>
    <article v-for="item in visible.slice(page * 20, (page + 1) * 20)" :key="item.evidence_id">
      <strong>{{ platformLabel(item.platform) }}</strong>
      <p>{{ item.excerpt }}</p>
      <a v-if="safeUrl(item.parent_url || item.url)" :href="safeUrl(item.parent_url || item.url)" target="_blank" rel="noopener noreferrer">打开评论所属原帖</a>
    </article>
    <nav v-if="visible.length > 20" aria-label="评论证据分页"><button :disabled="page === 0" @click="page--">上一页</button><span>第 {{ page + 1 }} / {{ Math.ceil(visible.length / 20) }} 页</span><button :disabled="(page + 1) * 20 >= visible.length" @click="page++">下一页</button></nav>
  </details>
</template>
<style scoped>
.report-evidence{margin:20px 0;line-height:1.8;overflow-wrap:anywhere}.report-evidence article{padding:12px 0;border-bottom:1px solid #dbe6ea}.report-evidence article p{white-space:pre-wrap}.report-evidence summary{cursor:pointer;min-height:44px}.report-evidence a{color:#08746d;text-decoration:underline}.report-evidence nav{display:flex;gap:12px;align-items:center;flex-wrap:wrap}.report-evidence button{min-height:44px;padding:8px 16px}
</style>
